import { Col, Container, Row } from 'react-bootstrap'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import service_bg from './../../assets/service_bg.png'
import img1 from './../../assets/Frame_1171275689.png'
import img2 from './../../assets/Frame_11712756881.png'
import icon1 from './../../assets/icons8_idea.png'
import icon2 from './../../assets/carbon_task-tools.png'
import icon3 from './../../assets/garden_security-26.png'
import icon4 from './../../assets/fluent_people-community-12-filled.png'

function Mssp() {
  return (
    <div className='wrap-hidden'>
      <div className='pb-5 pt-5'
        style={{
          backgroundImage: `url(${service_bg})`,
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "100% auto",
        }}
      >
        <Container className='mt-5 pt-5 pb-5'>
          <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
            <div className='mt-5 header text-center'><span className="text-brand-secondary">Managed Security</span> Service Provider</div>
            <p className='mt-4 text-justify text-center'><strong>Proactive Security. Real-Time Insight. Zero Gaps</strong></p>
            <p className='mt-4 stext-justify text-center'>In today’s threat landscape, reacting to cyberattacks isn't enough you need 24/7 vigilance, instant detection, and surgical response.</p>
            <p className='text-justify text-center'>As your extended security arm, Siberwander delivers always-on threat monitoring, intelligent detection, and expert-driven response, so you can sleep soundly while we watch your digital perimeter. Our MSSP capabilities are built to scale with your environment, integrate seamlessly into your cloud or hybrid stack, and reduce the operational burden on your internal teams while giving you real-time visibility and measurable outcomes.</p>
            <br/>
            <p className='text-justify text-center'>This isn’t just outsourced support.</p>
            <p className='text-justify text-center'>This is cybersecurity, fully managed, deeply integrated, and always ahead.</p>
          </AnimationOnScroll>

          <div className='mt-5 card-shadow'>
            <div className='bg-main-secondary-light pt-5 pb-5 ps-2 pe-2'>
              <div className='header text-center'>What <span className="text-brand-secondary">We Offer</span></div>
            </div>
            <div className='p-5 category ps-5 pe-5'>
              <Row className='align-items-center'>
                <Col xs={12} md={5} className='mb-3'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <h4><strong>Monitor & <span className="text-brand-secondary">Detect</span></strong></h4>
                    <div className='mt-3'><strong>See What Matters. Catch What Others Miss.</strong></div>
                    <p className='text-justify'>Step beyond surface level monitoring. We deliver context aware, risk prioritized visibility powered by machine learning, threat intelligence, and real time telemetry.</p>
                    <br/>
                    <p className='text-justify'>We don't just flag anomalies we translate signals into action, giving you the strategic foresight to preempt attacks before they manifest. Because in cybersecurity, seeing everything means nothing if you can’t spot what matters most.</p>
                    <div className='mt-3'><strong>Include Services:</strong></div>
                    <ul>
                      <li>Cyber Security Incident & Response Drill Exercise</li>
                      <li>Anti-Phishing & Brand Protection</li>
                      <li>Third Party Security Risk Management</li>
                      <li>24/7 Security Operations Center (SOC)</li>
                      <li>Advanced Vulnerability Management</li>
                      <li>Cyber Threat Intelligence</li>
                      <li>Compromise Assessment</li>
                      <li>Remote Penetration Testing</li>
                    </ul>
                  </AnimationOnScroll>
                </Col>
                <Col xs={12} md={1}/>
                <Col xs={12} md={6} className='mb-3 text-center'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <img src={img1} style={{width:'100%'}} alt=""/>
                  </AnimationOnScroll>
                </Col>
              </Row>
              <Row className='align-items-center mt-2'>
                <Col xs={12} md={6} className='mb-3 text-center'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <img src={img2} style={{width:'100%'}} alt=""/>
                  </AnimationOnScroll>
                </Col>
                <Col xs={12} md={1}/>
                <Col xs={12} md={5} className='mb-3'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <h4><strong>Respond & <span className="text-brand-secondary">React</span></strong></h4>
                    <div className='mt-3'><strong>Respond at Machine Speed, with Human Precision.</strong></div>
                    <p className='text-justify'>When every second counts, our response engine combines automated containment workflows with expert led analysis to eliminate threats before they escalate.</p>
                    <br/>
                    <p className='text-justify'>We act fast but we also go deep: performing forensic root cause assessments, extracting strategic learnings, and helping you embed resilience at the core of your operations. It’s not just about stopping the breach, it’s about making sure it never happens again.</p>
                    <div className='mt-3'><strong>Includes</strong></div>
                    <ul>
                      <li>Digital Forensics Investigation</li>
                      <li>Cyber Crisis Management</li>
                      <li>End-to-End Incident Response</li>
                    </ul>
                  </AnimationOnScroll>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>
      <Container className='pb-5'>
        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
          <div className='header text-center'>Why Choose  <span className="text-brand-secondary">Siberwander?</span></div>
          <p className='mt-4 text-justify text-center'><strong>Built for Practitioners. Designed for Progress. Powered by Community.</strong></p>
        </AnimationOnScroll>
        <div className='card-shadow mt-4 bg-main-secondary-light'>
          <div className='category ps-5 pe-5 pt-4'>
            <Row>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon1} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Effortless, Impactful Learning</strong></div>
                    <p className='text-center mt-2'>We use simplified, modern formats no boring theory dumps. Just clear, engaging content that sticks.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={100} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon2} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Real Tools. Real Scenarios. Real Readiness.</strong></div>
                    <p className='text-center mt-2'>Train with the same use cases and toolsets used by professionals in real-world environments.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={150} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon3} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Agentless-First Security Perspective</strong></div>
                    <p className='text-center mt-2'>Get ahead with a modern, frictionless approach to cloud security built for scale, speed, and visibility.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon4} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Community-Driven Ecosystem</strong></div>
                    <p className='text-center mt-2'>Grow with a network of learners, mentors, and practitioners because cybersecurity is stronger when shared.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Mssp